import * as axios from 'axios';
import { API } from './config';
import questions from '../../public/api/data.json';
import exemptions from '../../public/api/exemptions.json';

let responses = [];
let referrer = document.referrer;
let storage = window.localStorage;
let storedAnswers = storage.getItem("responses");
if (storedAnswers != null || storedAnswers != undefined) {
    responses = JSON.parse(storedAnswers);
}

//Retrieve a list of questions from a locally hosted json file.
const getData = async function () {
    try {
        const response = await axios.get(`${API}/data.json`);
        let data = parseList(response);
        const questions = data;
        return questions;
    } catch (error) {
        console.error(error);
        return [];
    }
};

const getQuestions = function () {
    return questions;
}

const resetResponses = function () {
    responses = [];
    storage.clear();
}

//Ensure that the data we are returning can be accessed and also contains an object data type
const parseList = response => {
    if (response.status != 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list != 'object') {
        list = [];
    }
    return list;
};

//Parse the current URL to ensure we retriece the correct question from the data
const parseUrl = function () {
    var splitUrl = window.location.href.split("/");
    return splitUrl[splitUrl.length - 1].trim("#");
};

//retrieve an element from our array based on the id matching the supplied propValue
const findElement = function (arr, propValue) {
    for (var i = 0; i < arr.length; i++)
        if (arr[i]["id"] == propValue) return arr[i];
    // will return undefined if not found; you could return a default instead
};

const findIndex = function (arr, propValue) {
    for (var i = 0; i < arr.length; i++)
        if (arr[i]["id"] == propValue) return i;
}

//log a users response to a question when the move to the next question
const logResponse = function (response) {
    let previousResponse = findElement(responses, response.id);
    if (previousResponse != undefined) {
        if (previousResponse.responses) {
            if (isEqual(previousResponse.responses, response.responses)) {
                return responses.length;
            } else {
                let removeIndex = responses.indexOf(previousResponse);
                responses.splice(removeIndex, 1);
                responses.push(response);
            }
        } else {
            let removeIndex = responses.indexOf(previousResponse);
            responses.splice(removeIndex, 1);
            responses.push(response);
        }
    } else {
        responses.push(response);
    }
    if (response.id == "PatientDetails") {
        rerouteForAge();
        console.log(response);
    }
    storage.clear();
    storage.setItem("responses", JSON.stringify(responses));
    return responses.length;
};

const rerouteForAge = function () {
    let patientCarerComplete = findIndex(questions.questions, "ParentQuestionnaireSectionComplete");  
    let patientDetails = findElement(responses, "PatientDetails");
    if (patientDetails.age > 4 && patientDetails.age < 11) {
        console.log("Rerouting to 5-10");
        questions.questions[patientCarerComplete].destination = "YoungPersonQuestionnaire8to10";
    } else if(patientDetails.age < 18 && parseList.age >10){
        console.log("Rerouting to 11-17");
        questions.questions[patientCarerComplete].destination = "YoungPersonQuestionnaire11to17"
    }else{
        console.log("Not eligible")
    }
}

const wasAnsweredBefore = function (id) {
    return findElement(responses, id);
}

//retrieve the user's responses for the results page
const getResponses = function () {
    return responses;
};

//retrieve the payment exemptions that apply to our current user based on their responses
const getExemptionsForUser = function () {
    let exemptions = getExemptions();
    let exempt = [];
    let notExempt = [];
    exemptions.exemptions.forEach(function (exemption) {
        if (isExempt(exemption)) {
            exempt.push(exemption.exemptionType);
        } else {
            notExempt.push(exemption.exemptionType);
        }
    });

    let userExemptions = {
        exempt: exempt,
        notExempt: notExempt
    };
    return userExemptions;
};

//logic to determine whether or not the user is exempt from payment for the passed in exemption
const isExempt = function (exemption) {
    if (exemption.criteria.length == 0) {
        return true;
    } else {
        let criteriaResults = [];
        let exempt = true;
        exemption.criteria.forEach(function (criteria) {
            let response = findElement(responses, criteria.id);
            if (response.questionType == "Checkbox") {
                response.responses.forEach(function (r) {
                    criteriaResults.push(isExemptForCriteria(criteria, r));
                });
            } else {
                criteriaResults.push(isExemptForCriteria(criteria, response));
            }
        });
        exempt = criteriaResults.some(function (result) {
            return result;
        });
        return exempt;
    }
}

const isExemptForCriteria = function (criteria, response) {
    if (criteria.exceptionCriteria == "less than") {
        if (response.responseId < criteria.exceptionValue && (criteria.mustAlso.length == 0 && criteria.shouldAlso.length == 0)) {
            return false;
        } else if (response.responseId < criteria.exceptionValue && criteria.mustAlso.length > 0) {
            let must = criteria.mustAlso.every(function (also) {
                var alsoResponse = findElement(responses, also.id);
                if (alsoResponse) {
                    if (alsoResponse.questionType == "Checkbox") {
                        let checkboxAlso = false;
                        alsoResponse.responses.forEach(function (a) {
                            checkboxAlso = isExemptForMust(also, a);
                        });
                        return checkboxAlso;
                    } else {
                        return isExemptForMust(also, alsoResponse);
                    }
                } else {
                    return true;
                }
            });
            return must;
        } else if (response.responseId < criteria.exceptionValue && criteria.shouldAlso.length > 0) {
            let should = criteria.shouldAlso.some(function (some) {
                var someResponse = findElement(responses, some.id);
                if (someResponse) {
                    if (someResponse.questionType == "Checkbox") {
                        let checkboxSome = someResponse.responses.some(function (s) {
                            return isExemptForShould(some, s);
                        });
                        return checkboxSome;
                    } else {
                        return isExemptForShould(some, someResponse);
                    }
                } else {
                    return false;
                }
            });
            return should;
        }
    } else if (criteria.exceptionCriteria == "greater than") {
        if (response.responseId > criteria.exceptionValue && (criteria.mustAlso.length == 0 && criteria.shouldAlso.length == 0)) {
            return false;
        } else if (response.responseId > criteria.exceptionValue && criteria.mustAlso.length > 0) {
            let must = criteria.mustAlso.every(function (also) {
                var alsoResponse = findElement(responses, also.id);
                if (alsoResponse) {
                    if (alsoResponse.questionType == "Checkbox") {
                        let checkboxAlso = false;
                        alsoResponse.responses.forEach(function (a) {
                            checkboxAlso = isExemptForMust(also, a);
                        });
                        return checkboxAlso;
                    } else {
                        return isExemptForMust(also, alsoResponse);
                    }
                } else {
                    return true;
                }
            });
            return must;
        } else if (response.responseId > criteria.exceptionValue && criteria.shouldAlso.length > 0) {
            let should = criteria.shouldAlso.some(function (some) {
                var someResponse = findElement(responses, some.id);
                if (someResponse) {
                    if (someResponse.questionType == "Checkbox") {
                        let checkboxSome = someResponse.responses.some(function (s) {
                            return isExemptForShould(some, s);
                        });
                        return checkboxSome;
                    } else {
                        return isExemptForShould(some, someResponse);
                    }
                } else {
                    return false;
                }
            });
            return should;
        }
    }
}

const isExemptForMust = function (also, alsoResponse) {
    if (also.exceptionCriteria == "less than") {
        if (alsoResponse.responseId < also.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else if (also.exceptionCriteria == "greater than") {
        if (alsoResponse.responseId > also.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else {
        if (alsoResponse.responseId == also.exceptionValue) {
            return true;
        } else {
            return false;
        }
    }
}

const isExemptForShould = function (some, someResponse) {
    if (some.exceptionCriteria == "less than") {
        if (someResponse.responseId < some.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else if (some.exceptionCriteria == "greater than") {
        if (someResponse.responseId > some.exceptionValue) {
            return true;
        } else {
            return false;
        }
    } else {
        if (someResponse.responseId == some.exceptionValue) {
            return true;
        } else {
            return false;
        }
    }
}

//retrieve a list of the exemptions a user may be entitled to from a locally hosted execptions json file
// const getExemptions = async function () {
//     try {
//         const response = await axios.get(`${API}/exemptions.json`);
//         let data = parseList(response);
//         const exemptions = data;
//         return exemptions;
//     } catch (error) {
//         console.error(error);
//         return [];
//     }
// };

const getExemptions = function () {
    return exemptions;
}

const getPatientData = function () {
    var age = findElement(responses, "PatientDetails").age;
    var withoutHelp = findElement(responses, "PatientDetails").withoutHelp;
    var formSubmissionModel = {
        age : age,
        withoutHelp: withoutHelp

    }
    return formSubmissionModel;
}
const getCompleteData = function () {
    console.log("Responses array:", responses);
    var patientDetails = findElement(responses, "PatientDetails");
    if (!patientDetails) {
        console.warn("PatientDetails not found in responses!");
        return {};
    }
    // patientDetails already defined above if present
    var day = patientDetails.day || "";
    var month = patientDetails.month || "";
    var year = patientDetails.year || "";
    var age = patientDetails.age || "";
    var hospitalId = patientDetails.hospitalId || "";
    var withoutHelp = patientDetails.withoutHelp || "";
    var additionalSupport = patientDetails.additionalSupport || "";
    var specialistSchool = patientDetails.specialistSchool || "";
    var supportText = patientDetails.supportText || "";
    var questionnaire = patientDetails.questionnaire || "";

    function safeGet(obj, path, fallback = "") {
        try {
            const result = path.reduce((acc, key) => acc && acc[key], obj);
            return (result === undefined || result === null) ? fallback : result;
        } catch { return fallback; }
    }

    var parentEpilepsyObj = findElement(responses, "ParentMeAndMyEpilepsyQuestionnaire") || {};
    var parentEpilepsy = {
        Hobbies: safeGet(parentEpilepsyObj, ["hobbies", "answer"]),
        QuestionFamily: safeGet(parentEpilepsyObj, ["questions", 0, "answer"]),
        QuestionFriends: safeGet(parentEpilepsyObj, ["questions", 1, "answer"]),
        QuestionSchool: safeGet(parentEpilepsyObj, ["questions", 2, "answer"]),
        QuestionMemory: safeGet(parentEpilepsyObj, ["questions", 3, "answer"]),
        QuestionFeelingSad: safeGet(parentEpilepsyObj, ["questions", 4, "answer"]),
        QuestionFeelingWorried: safeGet(parentEpilepsyObj, ["questions", 5, "answer"]),
        QuestionFeelingAngry: safeGet(parentEpilepsyObj, ["questions", 6, "answer"]),
        QuestionSleep: safeGet(parentEpilepsyObj, ["questions", 7, "answer"]),
        QuestionBehavior: safeGet(parentEpilepsyObj, ["questions", 8, "answer"]),
        QuestionComingToClinic: safeGet(parentEpilepsyObj, ["questions", 9, "answer"]),
        QuestionTakingMedication: safeGet(parentEpilepsyObj, ["questions", 10, "answer"]),
        QuestionTakingSeizure: safeGet(parentEpilepsyObj, ["questions", 11, "answer"]),
        Worries: safeGet(parentEpilepsyObj, ["worries", "answer"]),
        Help: safeGet(parentEpilepsyObj, ["help", "answer"]),
        Clinic: safeGet(parentEpilepsyObj, ["clinic", "answer"])
    };

    var parentSDQObj1 = findElement(responses, "ParentQuestionnaireSection1") || {};
    var parentSDQObj2 = findElement(responses, "ParentQuestionnaireSection2") || {};
    var parentSDQObj3 = findElement(responses, "ParentQuestionnaireSection3") || {};
    var parentSDQObj4 = findElement(responses, "ParentQuestionnaireSection4") || {};
    var parentSDQObj5 = findElement(responses, "ParentQuestionnaireSection5") || {};
    var parentSDQ = {
        Emo1Headaches: safeGet(parentSDQObj1, ["answer", 2, "answer"]),
        Emo2Worry: safeGet(parentSDQObj1, ["answer", 7, "answer"]),
        Emo3Unhappy: safeGet(parentSDQObj2, ["answer", 4, "answer"]),
        Emo4Nervous: safeGet(parentSDQObj2, ["answer", 7, "answer"]),
        Emo5Fears: safeGet(parentSDQObj3, ["answer", 7, "answer"]),
        Con1Angry: safeGet(parentSDQObj1, ["answer", 4, "answer"]),
        Con2Obedient: safeGet(parentSDQObj1, ["answer", 6, "answer"]),
        Con3Fight: safeGet(parentSDQObj2, ["answer", 3, "answer"]),
        Con4Cheating: safeGet(parentSDQObj3, ["answer", 1, "answer"]),
        Con5TakeThings: safeGet(parentSDQObj3, ["answer", 5, "answer"]),
        Hyp1Restless: safeGet(parentSDQObj1, ["answer", 1, "answer"]),
        Hyp2Fidgeting: safeGet(parentSDQObj2, ["answer", 1, "answer"]),
        Hyp3Distracted: safeGet(parentSDQObj2, ["answer", 6, "answer"]),
        Hyp4ThinkFirst: safeGet(parentSDQObj3, ["answer", 4, "answer"]),
        Hyp5Attention: safeGet(parentSDQObj3, ["answer", 8, "answer"]),
        Peer1PlayAlone: safeGet(parentSDQObj1, ["answer", 5, "answer"]),
        Peer2OneGoodFriend: safeGet(parentSDQObj2, ["answer", 2, "answer"]),
        Peer3PeopleLikeMe: safeGet(parentSDQObj2, ["answer", 5, "answer"]),
        Peer4BullyMe: safeGet(parentSDQObj3, ["answer", 2, "answer"]),
        Peer5AdultsOverChildren: safeGet(parentSDQObj3, ["answer", 6, "answer"]),
        Pro1CareAboutFeeling: safeGet(parentSDQObj1, ["answer", 0, "answer"]),
        Pro2Share: safeGet(parentSDQObj1, ["answer", 3, "answer"]),
        Pro3Helpful: safeGet(parentSDQObj2, ["answer", 0, "answer"]),
        Pro4Kind: safeGet(parentSDQObj3, ["answer", 0, "answer"]),
        Pro5Volunteer: safeGet(parentSDQObj3, ["answer", 3, "answer"])
    };

    var parentImpact = {
        HaveDifficulties: safeGet(parentSDQObj4, ["getalong"]),
        HowLongDifficulties: safeGet(parentSDQObj4, ["difficulties"]),
        Distress: safeGet(parentSDQObj4, ["distress"]),
        HomeLife: safeGet(parentSDQObj4, ["homelife"]),
        Friendships: safeGet(parentSDQObj4, ["friendships"]),
        Classroom: safeGet(parentSDQObj4, ["learning"]),
        Leisure: safeGet(parentSDQObj4, ["leisure"]),
        BurdenDifficulties: safeGet(parentSDQObj4, ["burden"]),
        AdditionalInformation: safeGet(parentSDQObj5, ["furtherInfo"])
    };

    var patientEpilepsyObj = findElement(responses, "YoungPersonMeAndMyEpilepsyQuestionnaire") || {};
    var patientEpilepsy = {
        Hobbies: safeGet(patientEpilepsyObj, ["hobbies", "answer"]),
        QuestionFamily: safeGet(patientEpilepsyObj, ["questions", 0, "answer"]),
        QuestionFriends: safeGet(patientEpilepsyObj, ["questions", 1, "answer"]),
        QuestionSchool: safeGet(patientEpilepsyObj, ["questions", 2, "answer"]),
        QuestionMemory: safeGet(patientEpilepsyObj, ["questions", 3, "answer"]),
        QuestionFeelingSad: safeGet(patientEpilepsyObj, ["questions", 4, "answer"]),
        QuestionFeelingWorried: safeGet(patientEpilepsyObj, ["questions", 5, "answer"]),
        QuestionFeelingAngry: safeGet(patientEpilepsyObj, ["questions", 6, "answer"]),
        QuestionSleep: safeGet(patientEpilepsyObj, ["questions", 7, "answer"]),
        QuestionBehavior: safeGet(patientEpilepsyObj, ["questions", 8, "answer"]),
        QuestionComingToClinic: safeGet(patientEpilepsyObj, ["questions", 9, "answer"]),
        QuestionTakingMedication: safeGet(patientEpilepsyObj, ["questions", 10, "answer"]),
        QuestionTakingSeizure: safeGet(patientEpilepsyObj, ["questions", 11, "answer"]),
        Worries: safeGet(patientEpilepsyObj, ["worries", "answer"]),
        Help: safeGet(patientEpilepsyObj, ["help", "answer"]),
        Clinic: safeGet(patientEpilepsyObj, ["clinic", "answer"])
    };

    var patientSDQ = {};
    var patientImpact = {};
    if (age > 10 && age < 18 && withoutHelp == "Yes") {
        var patientSDQObj1 = findElement(responses, "YoungPersonQuestionnaire11to17Section1") || {};
        var patientSDQObj2 = findElement(responses, "YoungPersonQuestionnaire11to17Section2") || {};
        var patientSDQObj3 = findElement(responses, "YoungPersonQuestionnaire11to17Section3") || {};
        var patientSDQObj4 = findElement(responses, "YoungPersonQuestionnaire11to17Section4") || {};
        var patientSDQObj5 = findElement(responses, "YoungPersonQuestionnaire11to17Section5") || {};
        patientSDQ = {
            Emo1Headaches: safeGet(patientSDQObj1, ["answer", 2, "answer"]),
            Emo2Worry: safeGet(patientSDQObj1, ["answer", 7, "answer"]),
            Emo3Unhappy: safeGet(patientSDQObj2, ["answer", 4, "answer"]),
            Emo4Nervous: safeGet(patientSDQObj2, ["answer", 7, "answer"]),
            Emo5Fears: safeGet(patientSDQObj3, ["answer", 7, "answer"]),
            Con1Angry: safeGet(patientSDQObj1, ["answer", 4, "answer"]),
            Con2Obedient: safeGet(patientSDQObj1, ["answer", 6, "answer"]),
            Con3Fight: safeGet(patientSDQObj2, ["answer", 3, "answer"]),
            Con4Cheating: safeGet(patientSDQObj3, ["answer", 1, "answer"]),
            Con5TakeThings: safeGet(patientSDQObj3, ["answer", 5, "answer"]),
            Hyp1Restless: safeGet(patientSDQObj1, ["answer", 1, "answer"]),
            Hyp2Fidgeting: safeGet(patientSDQObj2, ["answer", 1, "answer"]),
            Hyp3Distracted: safeGet(patientSDQObj2, ["answer", 6, "answer"]),
            Hyp4ThinkFirst: safeGet(patientSDQObj3, ["answer", 4, "answer"]),
            Hyp5Attention: safeGet(patientSDQObj3, ["answer", 8, "answer"]),
            Peer1PlayAlone: safeGet(patientSDQObj1, ["answer", 5, "answer"]),
            Peer2OneGoodFriend: safeGet(patientSDQObj2, ["answer", 2, "answer"]),
            Peer3PeopleLikeMe: safeGet(patientSDQObj2, ["answer", 5, "answer"]),
            Peer4BullyMe: safeGet(patientSDQObj3, ["answer", 2, "answer"]),
            Peer5AdultsOverChildren: safeGet(patientSDQObj3, ["answer", 6, "answer"]),
            Pro1CareAboutFeeling: safeGet(patientSDQObj1, ["answer", 0, "answer"]),
            Pro2Share: safeGet(patientSDQObj1, ["answer", 3, "answer"]),
            Pro3Helpful: safeGet(patientSDQObj2, ["answer", 0, "answer"]),
            Pro4Kind: safeGet(patientSDQObj3, ["answer", 0, "answer"]),
            Pro5Volunteer: safeGet(patientSDQObj3, ["answer", 3, "answer"])
        };
        patientImpact = {
            HaveDifficulties: safeGet(patientSDQObj4, ["getalong"]),
            HowLongDifficulties: safeGet(patientSDQObj4, ["difficulties"]),
            Distress: safeGet(patientSDQObj4, ["distress"]),
            HomeLife: safeGet(patientSDQObj4, ["homelife"]),
            Friendships: safeGet(patientSDQObj4, ["friendships"]),
            Classroom: safeGet(patientSDQObj4, ["learning"]),
            Leisure: safeGet(patientSDQObj4, ["leisure"]),
            BurdenDifficulties: safeGet(patientSDQObj4, ["burden"]),
            AdditionalInformation: safeGet(patientSDQObj5, ["furtherInfo"])
        };
    }

    var formSubmissionModel = {
        SubmissionId: "",
        FullName: patientDetails.fullname || "",
        DateOfBirth: (day && month && year) ? new Date(year, month - 1, day) : "",
        Age : age,
        HospitalId: hospitalId,
        WithoutHelp : withoutHelp,
        SpecialistSchool: specialistSchool,
        AdditionalSupport: additionalSupport,
        SupportText: supportText,
        Questionnaire: questionnaire,
        ParentEpilepsy: parentEpilepsy,
        ParentSDQ: parentSDQ,
        ParentImpact: parentImpact,
        PatientEpilepsy: patientEpilepsy,
        PatientSDQ: patientSDQ,
        PatientImpact: patientImpact,
        ReferrerUrl: referrer
    }
    console.log(formSubmissionModel);
    return formSubmissionModel;
}

const isEqual = function (a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;
  
    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.
  
    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

export const dataService = {
    getData, getQuestions, resetResponses, parseUrl, findElement, findIndex, logResponse, wasAnsweredBefore, getResponses, getExemptionsForUser, getCompleteData, getPatientData
};
